(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* --- Color dot click: swap image, title, price without reload --- */
  document.addEventListener("click", function (e) {
    var dot = e.target.closest(".color-dot");
    if (!dot) return;
    var card = dot.closest(".pcard, [data-pcard]");
    if (!card) return;
    var newImage = dot.dataset.image;
    var newTitle = dot.dataset.title;
    var newPrice = dot.dataset.price;
    var newUrl = dot.dataset.url;
    var newHandle = newUrl.split('/products/')[1];

    var mediaLink = card.querySelector(".pcard__media-link");
    if (mediaLink) {
      mediaLink.innerHTML = '<img src="' + newImage + '" alt="' + newTitle + '" style="width:100%;height:100%;object-fit:cover;">';
      mediaLink.href = newUrl;
    }

    var title = card.querySelector(".pcard__name");
    if (title) { title.textContent = newTitle; title.href = newUrl; }

    var price = card.querySelector(".pcard__price");
    if (price) { price.innerHTML = window.STMNBtb && window.STMNBtb.rate(dot.dataset.url) ? window.STMNBtb.html(dot.dataset.cents,dot.dataset.url) : newPrice; }

    // Availability and badges belong to the selected color product.
    if (dot.dataset.available !== undefined) {
      var available = dot.dataset.available === 'true';
      var rate = window.STMNBtb ? window.STMNBtb.rate(newUrl) : 0;
      var onSale = Number(dot.dataset.compareCents) > Number(dot.dataset.cents);
      card.querySelectorAll('.pcard__badge').forEach(function (badge) { badge.remove(); });
      if (dot.dataset.showBadge === 'true') {
        var kind = !available ? 'soldout' : rate || onSale ? 'sale' : dot.dataset.customBadge ? 'tag' : '';
        if (kind) {
          var badge = document.createElement('span'); badge.className = 'pcard__badge pcard__badge--' + kind;
          badge.textContent = !available ? dot.dataset.soldoutLabel : rate ? '−' + rate + '%' : onSale ? dot.dataset.saleLabel : dot.dataset.customBadge;
          card.querySelector('.pcard__media').appendChild(badge);
        }
      }
      var compare = card.querySelector('.pcard__compare');
      if (compare) compare.remove();
      if (price) {
        price.classList.toggle('pcard__price--sale', onSale);
        if (onSale && !rate) { compare = document.createElement('span'); compare.className = 'pcard__compare'; compare.textContent = dot.dataset.comparePrice; price.insertAdjacentElement('afterend', compare); }
      }
      var colorAtc = card.querySelector('.pcard__atc-btn');
      if (colorAtc) { colorAtc.disabled = !available; colorAtc.style.display = available ? '' : 'none'; }
    }
    var atcBtn = card.querySelector(".pcard__atc-btn");
    if (atcBtn && newHandle) {
      atcBtn.setAttribute('onclick', "window.openQuickAdd && openQuickAdd('" + newHandle + "')");
    }

    card.querySelectorAll("a[href]").forEach(function(a) {
      if (!a.classList.contains("color-dot") && !a.closest(".pcard__colors")) {
        a.href = newUrl;
      }
    });
  });

  /* --- Mobile swipe dots --- */
  document.querySelectorAll('[data-pcard-swipe]').forEach(function (swipe) {
    var card = swipe.closest('[data-pcard]');
    if (!card) return;
    var dots = card.querySelectorAll('[data-dot]');
    if (!dots.length) return;

    var slides = swipe.querySelectorAll('.pcard__slide');
    var current = 0;

    swipe.addEventListener('scroll', function () {
      var scrollLeft = swipe.scrollLeft;
      var slideWidth = swipe.offsetWidth;
      var index = Math.round(scrollLeft / slideWidth);
      if (index !== current && index >= 0 && index < slides.length) {
        dots[current].classList.remove('pcard__dot--active');
        current = index;
        dots[current].classList.add('pcard__dot--active');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
